import React from 'react';
import { UserCircle, LogOut } from 'lucide-react';
import { useApp } from '../context/AppContext';
import Layout from './Layout';

const ProfilePage = ({ onNav }) => {
  const { user, logout } = useApp();

  return (
    <Layout activeTab="profile" onNav={onNav}>
      <header className="py-12 flex flex-col items-center">
        <div className="w-24 h-24 bg-purple-600 rounded-full flex items-center justify-center shadow-2xl mb-4 border-4 border-white/5">
          <UserCircle size={60} />
        </div>
        <h2 className="text-2xl font-black">
          {user?.firstName} {user?.lastName}
        </h2>
        <p className="text-gray-500 text-[10px] font-black uppercase tracking-widest">{user?.email}</p>
        <button
          onClick={() => {
            logout();
            onNav('login');
          }}
          className="mt-12 w-full flex items-center justify-center gap-3 bg-red-600/10 text-red-500 border border-red-500/20 py-5 rounded-2xl font-black text-xs active:scale-95 transition-all hover:bg-red-600 hover:text-white uppercase tracking-widest"
        >
          <LogOut size={18} /> Logout Session
        </button>
      </header>
    </Layout>
  );
};

export default ProfilePage;
